import React, {useEffect, useState} from 'react';
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import _ from "lodash";
import GenerateContentFromPrompt from "../../../openai/components/generate-content-from-prompt";

const SelectPrompt = ({
                          promptsList,
                          title = '',
                          url = '',
                          subTypeList,
                          contentTags = '',
                          toneOfVoice = '',
                          hideTitle = false,
                          setContentText = undefined,
                          cssClass = '',
                      }) => {

    const preparePromptText = (prompt) => {
        let promptText = prompt.title + '\n';

        if (!_.isEmpty(title)) {
            promptText += 'Title: "' + title + '"\n';
        }

        if (!_.isEmpty(url)) {
            promptText += 'URL: "' + url + '"\n';
        }

        if (!_.isEmpty(toneOfVoice)) {
            promptText += 'Tone of Voice: "' + toneOfVoice + '"\n';
        }

        if (!_.isEmpty(contentTags)) {
            promptText += 'Keywords: "' + contentTags + '"\n';
        }

        return promptText;
    }

    return (
        <>

            <div className="flex justify-start flex-wrap">
                {promptsList?.map((prompt, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                        {subTypeList?.includes(prompt.subType) &&
                            <div
                                className={`${cssClass} ${!hideTitle ? 'shadow-lg my-1 mx-2 p-2 bg-white border border-gray-800 bg-gray-50 rounded' : ''}`}>
                                <div className="flex justify-between text-left items-center">
                                    {!hideTitle &&
                                        <div className={'pl-2'}>{prompt.title}</div>
                                    }

                                    <div className="ml-2">
                                        <GenerateContentFromPrompt
                                            setContentText={setContentText}
                                            promptTitle={subTypeList.toString()}
                                            promptContent={preparePromptText(prompt)}/>

                                        <CopyDataToClipboard
                                            value={preparePromptText(prompt)}/>
                                    </div>

                                </div>
                            </div>
                        }
                    </React.Fragment>
                ))}
            </div>

        </>
    )
}

export default SelectPrompt
